import { Divider, Grid2 as Grid, Typography } from '@mui/material';

export type FormSectionProps = {
  title: string;
  children: React.ReactNode;
};

export const FormSection = ({ title, children }: FormSectionProps) => (
  <Grid container spacing={4} alignItems='flex-start' sx={{ mb: 4 }}>
    {/* Section Title */}
    <Grid
      size={{ xs: 12, md: 2 }}
      display='flex'
      alignItems='center'
      justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
      textAlign={{ xs: 'center', md: 'right' }}
    >
      <Typography variant='h6'>{title}</Typography>
    </Grid>
    {/* Divider: hide on xs */}
    <Divider
      orientation='vertical'
      flexItem
      sx={{
        mx: 2,
        display: { xs: 'none', md: 'block' },
      }}
    />
    <Grid size={{ xs: 12, md: 8 }}>{children}</Grid>
  </Grid>
);
